import { combineReducers } from "redux";

import { formReducer } from "./post-form.model";

const reducerKey = "@feature/post";

export function getPostFeatureReducer() {
  return {
    [reducerKey]: combineReducers({
      form: formReducer,
    }),
  };
}

type PostFeatureRootState = {
  [reducerKey]: {
    form: ReturnType<typeof formReducer>;
  };
};

export const postFormSelector = (state: PostFeatureRootState) =>
  state[reducerKey].form;
